import type { TFunction } from "i18next";
import type { Tournament } from "./types";

/**
 * A race (`subtype` "RA") is a point tournament that counts only each player's first
 * `campaign.max_spins` qualifying spins. It renders through every tournament view; the spin cap
 * shows wherever `max_spins` / `left_spins` are present, so only its name (and the home card's
 * badge icon) tell it apart — ask here rather than comparing subtype codes in a component.
 */
export const isRace = (tournament: Pick<Tournament, "subtype">): boolean =>
  tournament.subtype === "RA";

/** What a tournament-module campaign is called: the type badge and the finished heading. */
export const tournamentLabels = (
  tournament: Pick<Tournament, "subtype">,
  t: TFunction
): { type: string; finished: string } =>
  isRace(tournament)
    ? {
        type: t("campaign.typeRace", "Race"),
        finished: t("campaign.raceFinished", "Race finished"),
      }
    : {
        type: t("campaign.typeTournament", "Tournament"),
        finished: t("campaign.tournamentFinished", "Tournament finished"),
      };
